import axios from 'axios';
import { router } from '../router';
import { Message } from 'element-ui';
import {
  getToken, removeToken
} from './auth';

// 创建axios实例
const fetch = axios.create({
  baseURL: '/',
  timeout: 30000
});

// request拦截器
fetch.interceptors.request.use(config => {
  // Do something before request is sent
  if (getToken()) {
    config.headers.Authorization = getToken(); // 让每个请求携带token
  }
  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
});

// respone拦截器
fetch.interceptors.response.use(
  response => {
    /**
         * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
         * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
         */
    let res = response.data;
    if (response.status === 401 || res.status === 40101) {
      removeToken();
      router.push({
        name: 'login'
      });
      return Promise.reject(response.message);
    }
    if (res.status === 40301) {
      Message.error('当前用户无相关操作权限！');
      return Promise.reject(response.message);
    }
    if (res.status === 40001) {
      Message.error('账户或密码错误！');
      return Promise.reject(response.message);
    }
    if (res.status === 40102) {
      Message.error(res.message || '账户锁定！');
      return Promise.reject(response.message);
    }
    if (res.status === 40002) {
      Message.error('请输入正确的验证码！');
      return Promise.reject(response);
    }
    if (res.status === 40003) {
      Message.error('账户或密码错误！');
      return Promise.reject(response);
    }
    //修复arraybuffer不能展示错误提示的问题
    if(response.request.responseType === 'arraybuffer'){
      //将arraybuffer转成字符串
      const decoder = new TextDecoder('utf-8');
      const text = decoder.decode(res);
      try {
        //说明接口实际返回的是需要展示的提示（json对象）
        res = JSON.parse(text)
      } catch (error) { 

      }
    }

    if (res.status && res.status !== 200 && res.status !== 201) {
      Message.error(res.message || '系统忙，请稍后再试！');
      return Promise.reject(res); 
    } else {
      return response.data;
    }
  },
  error => {
    Message.error('系统忙，请稍后再试！');
    return Promise.reject(error);
  }
);

export default fetch;



// WEBPACK FOOTER //
// ./src/utils/fetch.js